import { render } from "./ModalCadastrarProjeto.vue?vue&type=template&id=90043a94&scoped=true"
import script from "./ModalCadastrarProjeto.vue?vue&type=script&lang=js"
export * from "./ModalCadastrarProjeto.vue?vue&type=script&lang=js"

import "./ModalCadastrarProjeto.vue?vue&type=style&index=0&id=90043a94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90043a94"]])

export default __exports__